import React from "react";

export const Features = () => {
  return (
    <div className="flex flex-col text-center">
      <h2 className="font-semibold text-lg sm:font-bold sm:text-2xl mb-2">
        Features at a glance
      </h2>
      <h3>this section is coming soon! Stay tuned!</h3>
    </div>
  );
};
